import { dayjs } from '@/time';

export type PostDaySeparatorTranslate = (
  key:
    | 'components.postDaySeparator.today'
    | 'components.postDaySeparator.yesterday'
) => string;

export const getPostDayLabel = (
  dayStart: number,
  t: PostDaySeparatorTranslate
): string => {
  const today = dayjs().startOf('day');
  const daysInPast = today.diff(dayjs(dayStart), 'day');
  if (daysInPast === 0) {
    return t('components.postDaySeparator.today');
  }
  if (daysInPast === 1) {
    return t('components.postDaySeparator.yesterday');
  }
  return dayjs(dayStart).format('DD.MM.YYYY');
};
